export default {
  data () {
    return {
      resizeTracker: {
        prevWidth: null,
        prevHeight: null,
        prevOrientation: null,
        handler: null,
        debounceDelay: 300
      }
    }
  },
  methods: {
    initResizeTracker () {
      const { innerWidth, innerHeight } = window

      this.resizeTracker.prevWidth = innerWidth
      this.resizeTracker.prevHeight = innerHeight
      this.resizeTracker.prevOrientation = this.getOrientation(innerWidth, innerHeight)

      // Сохраняем обработчик с правильным контекстом
      this.resizeTracker.handler = this.debounce(
        this.handleResize.bind(this),
        this.resizeTracker.debounceDelay
      )

      window.addEventListener('resize', this.resizeTracker.handler, { passive: true })
    },
    destroyResizeTracker () {
      if (this.resizeTracker.handler) {
        window.removeEventListener('resize', this.resizeTracker.handler)
        this.resizeTracker.handler = null
      }
    },
    debounce (fn, delay) {
      let timeoutId
      return (...args) => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => fn(...args), delay)
      }
    },
    getOrientation (width, height) {
      return width > height ? 'landscape' : 'portrait'
    },
    detectResizeReason (oldW, oldH, newW, newH) {
      const widthDiff = Math.abs(newW - oldW)
      const heightDiff = Math.abs(newH - oldH)

      // Конфигурация порогов
      const thresholds = {
        minor: 50,
        orientation: 150,
        major: 200
      }

      if (widthDiff < thresholds.minor && heightDiff < thresholds.minor) {
        return 'Возможно, изменение DPI или масштаб страницы'
      }

      if (widthDiff > thresholds.orientation && heightDiff > thresholds.orientation) {
        return 'Вероятно, изменение ориентации устройства'
      }

      if (widthDiff > thresholds.major && heightDiff < thresholds.minor) {
        return 'Изменена ширина окна'
      }

      if (heightDiff > thresholds.major && widthDiff < thresholds.minor) {
        return 'Изменена высота окна'
      }

      return 'Общее изменение размера окна'
    },
    handleResize () {
      const { innerWidth: newWidth, innerHeight: newHeight } = window
      const newOrientation = this.getOrientation(newWidth, newHeight)

      const { prevWidth, prevHeight, prevOrientation } = this.resizeTracker

      // Избегаем лишних вычислений, если размер не изменился
      if (newWidth === prevWidth && newHeight === prevHeight) {
        return
      }

      const resizeData = {
        from: { width: prevWidth, height: prevHeight, orientation: prevOrientation },
        to: { width: newWidth, height: newHeight, orientation: newOrientation },
        reason: this.detectResizeReason(prevWidth, prevHeight, newWidth, newHeight),
        orientationChanged: prevOrientation !== newOrientation
      }

      this.logResize(resizeData)

      // Обновляем сохраненные значения
      this.resizeTracker.prevWidth = newWidth
      this.resizeTracker.prevHeight = newHeight
      this.resizeTracker.prevOrientation = newOrientation
    },
    logResize (data) {
      const { from, to, reason, orientationChanged } = data

      console.group('[TABLO] Изменение размера окна')
      console.log(`С: ${from.width}×${from.height} (${from.orientation})`)
      console.log(`На: ${to.width}×${to.height} (${to.orientation})`)
      console.log(`Причина: ${reason}`)

      if (orientationChanged) {
        console.log(`Изменение ориентации: ${from.orientation} → ${to.orientation}`)
      }

      console.groupEnd()
    }
  },
  mounted () {
    this.initResizeTracker()
  },
  beforeDestroy () {
    this.destroyResizeTracker()
  }
}
